import { Link } from "react-router-dom";
import MediaCard from "@/components/base/MediaCard";
import { useFavorites } from "@/hooks/useFavorites";
import { allMedia } from "@/utils/media";
import { useDocumentTitle } from "@/hooks/useDocumentTitle";

export default function FavoritesPage() {
  const { favorites, removeFavorite } = useFavorites();
  const list = allMedia.filter((item) => favorites.includes(item.id));

  useDocumentTitle(
    "我的收藏 - 91免费影视",
    "查看你收藏的影视作品。收藏数据保存在浏览器本地，无需登录即可使用。",
  );

  const clearAll = () => {
    [...list].forEach((item) => removeFavorite(item.id));
  };

  return (
    <div className="mx-auto w-full px-4 py-8 md:px-6 md:py-10">
      <nav className="flex items-center gap-1.5 text-sm text-foreground-500">
        <Link to="/" className="transition-colors hover:text-primary-600">
          首页
        </Link>
        <i className="ri-arrow-right-s-line" />
        <span className="font-medium text-foreground-800">我的收藏</span>
      </nav>

      <div className="mt-5 flex flex-wrap items-end justify-between gap-3">
        <div>
          <h1 className="flex items-center gap-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-accent-500 text-primary-950">
              <i className="ri-heart-3-line text-2xl" />
            </span>
            我的收藏
          </h1>
          <p className="mt-2 text-sm text-foreground-600">
            收藏保存在浏览器本地，无需登录，刷新后依然保留。当前共收藏{" "}
            <strong className="text-accent-600">{list.length}</strong> 部作品。
          </p>
        </div>
        {list.length > 0 && (
          <button
            type="button"
            onClick={clearAll}
            className="flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-4 py-2 text-sm font-medium text-foreground-700 transition-colors hover:border-accent-400 hover:text-accent-700"
          >
            <i className="ri-delete-bin-6-line" />
            清空收藏
          </button>
        )}
      </div>

      {list.length > 0 ? (
        <div className="mt-8 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-5">
          {list.map((item) => (
            <MediaCard key={item.id} media={item} />
          ))}
        </div>
      ) : (
        <div className="mt-8 flex flex-col items-center rounded-lg bg-background-50 px-6 py-16 text-center ring-1 ring-background-200">
          <span className="flex h-16 w-16 items-center justify-center rounded-full bg-secondary-100 text-3xl text-foreground-400">
            <i className="ri-heart-3-line" />
          </span>
          <h3 className="mt-5 font-heading text-lg font-bold text-foreground-900">还没有收藏任何作品</h3>
          <p className="mt-2 max-w-md text-sm text-foreground-500">
            浏览影视列表或详情页时，点击右上角的爱心按钮即可把喜欢的作品收藏到这里。
          </p>
          <Link
            to="/"
            className="mt-6 rounded-md bg-primary-500 px-6 py-2.5 text-sm font-bold text-background-50 transition-colors hover:bg-primary-600"
          >
            去发现好作品
          </Link>
        </div>
      )}
    </div>
  );
}